import React from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { getId, isLastElement } from 'globals/utils';
import useTheme from '@material-ui/core/styles/useTheme';
import FsSingleBarGraph from 'ui-elements/charts/FsSingleBarGraph';
import { FsSingleBarGraphDataProps } from 'ui-elements/charts/FsSingleBarGraph/FsSingleBarGraph';
import {
  GraphContainerBox,
  Value,
  Caption,
  InfoBox,
} from './Fs3ChartsBoxContent.style-elements';
import {
  getFirstInfoBoxItemInRowStyle,
  getFsSingleBarGraphStyle,
  getSingleBarGraphColor,
} from './Fs3ChartsBoxContent.style';

export interface Fs3ChartsBoxContentInfoBoxDataProps {
  caption: string;
  displayValue: () => string;
}

export interface Fs3ChartsBoxContentDataProps {
  graphs: FsSingleBarGraphDataProps[];
  infoBoxItems: Fs3ChartsBoxContentInfoBoxDataProps[];
}

interface Fs3ChartsBoxContentProps extends Fs3ChartsBoxContentDataProps {
  colorArray?: string[];
}

const Fs3ChartsBoxContent: React.FC<Fs3ChartsBoxContentProps> = ({
  graphs = [],
  infoBoxItems = [],
  colorArray = [],
}) => {
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <>
      <GraphContainerBox>
        {graphs.map(({ value, barValue, description, title }, idx) => (
          <FsSingleBarGraph
            data-test="single-bar-graph"
            key={getId()}
            value={value}
            barWidth={42}
            barHeight={100}
            barColor={getSingleBarGraphColor(idx, colorArray)}
            barValue={barValue}
            title={title}
            description={description}
            wrapWords={false}
            style={getFsSingleBarGraphStyle()}
            isLastElement={isLastElement(idx, graphs.length)}
          />
        ))}
      </GraphContainerBox>
      <Box display="flex" flexWrap="wrap">
        {infoBoxItems.map(({ caption, displayValue }, idx) => (
          <InfoBox
            data-test="info-box"
            key={getId()}
            style={getFirstInfoBoxItemInRowStyle(idx, isUpSm)}
          >
            <Caption>{caption}</Caption>
            <Value>{displayValue()}</Value>
          </InfoBox>
        ))}
      </Box>
    </>
  );
};

export default Fs3ChartsBoxContent;
